// Display symbols for the currency pickers (header + footer). Codes without
// an entry fall back to the code itself.
export const CURRENCY_SYMBOLS = {
  THB: '฿', USD: '$', EUR: '€', RUB: '₽', CNY: '¥', SGD: 'S$', MYR: 'RM', IDR: 'Rp',
  VND: '₫', PHP: '₱', KHR: '៛', GBP: '£', AUD: 'A$', JPY: '¥', KRW: '₩',
}

export function currencySymbol(code) {
  return CURRENCY_SYMBOLS[String(code || '').toUpperCase()] || String(code || '')
}
